import ProductWaterfall from "@/components/product-waterfall";
import React from "react";
import { useHasNext, useLoadMore, useProductList } from "../hooks/useFollowProduct";

interface IProps {
  provideBackground?: boolean;
  onCartChange?: () => void;
}

const ProductList: React.FC<IProps> = props => {
  const productList = useProductList();
  const hasNext = useHasNext();
  const loadMore = useLoadMore();

  return (
    <ProductWaterfall
      productList={productList}
      hasNext={hasNext}
      loadMore={loadMore}
      provideBackground={props.provideBackground}
      topRightLocationCode="H5_FollowProduct_SmallList_ProductPicRight"
      titleFrontLocationCode="H5_FollowProduct_SmallList_TitleFront"
      titleBottomLocationCode="H5_FollowProduct_SmallList_TitleDown"
      onCartChange={props.onCartChange}
    />
  );
};

export default ProductList;
